module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG5adf7b382decbc2b0222481272ddf408.5adf7b38.png";